var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-tag',{attrs:{"type":_vm.setting.type}},[_vm._v(_vm._s(_vm.setting.text))])}
var staticRenderFns = []

export { render, staticRenderFns }